import { Loader } from 'components';
import { NotificationSettingsForm } from './NotificationSettingsForm';
import { FC } from 'react';

import { useGlobalNotifcationSetting, useGlobalNotificationSettingsSave } from './settingsApi';

export const AdminNotificationSettings: FC = () => {
  const { data: notificationSettings, isLoading: notificationSettingsFetchingInProgress } =
    useGlobalNotifcationSetting();
  const { mutate: notificationMutation, isLoading } = useGlobalNotificationSettingsSave();

  return notificationSettingsFetchingInProgress ? (
    <Loader />
  ) : notificationSettings ? (
    <NotificationSettingsForm
      notificationSettings={notificationSettings}
      isLoading={isLoading}
      saveAction={notificationMutation}
    />
  ) : (
    <p> Something went wrong </p>
  );
};
